import { gql } from "@apollo/client";

const ADD_COLLECTION = gql`
  mutation addCollection($id: Float!) {
    addCollection(id: $id) {
      __typename
      ... on Collection {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const CREATE_COLLECTION = gql`
  mutation createCollection($input: CreateCollectionInput!) {
    createCollection(input: $input) {
      __typename
      ... on Collection {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
const UPDATE_COLLECTION = gql`
  mutation updateCollection($input: UpdateCollectionInput!) {
    updateCollection(input: $input) {
      __typename
      ... on Collection {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const DELETE_COLLECTION = gql`
  mutation deleteCollection($id: Float!) {
    deleteCollection(id: $id) {
      __typename
      ... on Collection {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const LINK_IMAGE_WITH_COLLECTION = gql`
  mutation linkImageWithCollection($input: LinkImageWithCollection!) {
    linkImageWithCollection(input: $input) {
      __typename
      ... on Collection {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
export {
  ADD_COLLECTION,
  CREATE_COLLECTION,
  UPDATE_COLLECTION,
  DELETE_COLLECTION,
  LINK_IMAGE_WITH_COLLECTION,
};
